import React, { useEffect, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Button, Paper, Stack, Typography } from '@mui/material';
import { ANALYTICS_SETTINGS_EVENT, readAnalyticsConsent, setAnalyticsConsent } from '../utils/analytics';

export default function CookieConsent() {
  const [open, setOpen] = useState(() => !readAnalyticsConsent());

  useEffect(() => {
    const showSettings = () => setOpen(true);
    window.addEventListener(ANALYTICS_SETTINGS_EVENT, showSettings);
    return () => window.removeEventListener(ANALYTICS_SETTINGS_EVENT, showSettings);
  }, []);

  if (!open) {
    return null;
  }

  const acceptAnalytics = () => {
    setAnalyticsConsent('analytics');
    setOpen(false);
  };

  const rejectAnalytics = () => {
    setAnalyticsConsent('necessary');
    setOpen(false);
  };

  return (
    <Paper
      elevation={8}
      sx={{
        position: 'fixed',
        right: { xs: 12, md: 24 },
        bottom: { xs: 12, md: 24 },
        left: { xs: 12, sm: 'auto' },
        width: { xs: 'auto', sm: 440 },
        zIndex: 2000,
        p: 2,
        borderRadius: 2,
        border: '1px solid rgba(255,255,255,0.12)',
      }}
    >
      <Stack spacing={1.5}>
        <Box>
          <Typography variant="subtitle1" sx={{ fontWeight: 800 }}>
            Cookies i analityka
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Używamy mechanizmów niezbędnych do działania serwisu. Google Analytics włączymy tylko po Twojej zgodzie.
          </Typography>
        </Box>
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1}>
          <Button variant="contained" onClick={acceptAnalytics}>
            Akceptuję analitykę
          </Button>
          <Button variant="outlined" onClick={rejectAnalytics}>
            Odrzucam
          </Button>
          <Button
            component={RouterLink}
            to="/dokumenty/cookies"
            variant="text"
            sx={{ textDecoration: 'none' }}
          >
            Szczegóły
          </Button>
        </Stack>
        <Typography variant="caption" color="text.secondary">
          Ustawienia możesz zmienić w każdej chwili przez „Ustawienia analityki” w stopce.
        </Typography>
      </Stack>
    </Paper>
  );
}
